import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { id: "input-wrapper" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "company-input" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "businesstype-inputs" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "business-inputs" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "company-input" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "phone-inputs" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "phone-inputs" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "email-inputs" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "address-inputs" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "company-input" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "address-inputs" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "company-input" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "filebox" }
const _hoisted_28 = { style: {"font-size":"14px"} }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "filebox" }
const _hoisted_31 = { style: {"font-size":"14px"} }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = { class: "filebox" }
const _hoisted_34 = { style: {"font-size":"14px"} }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "company-input" }
const _hoisted_37 = ["src"]

import userAPI from "@/api/userAPI";
import UserFileUploadPop from "@/components/popup/UserFileUploadPop.vue";
import { Member, MemberFileParam, saveFile } from "@/common/types";
import { formatTimeAgo, isEmpty } from "@/common/util";
import { reactive, onMounted, ref, onBeforeUnmount } from "vue";
// 상태 관리

export default /*@__PURE__*/_defineComponent({
  __name: 'MyPageView',
  setup(__props) {

const form = reactive({
  companyName: "",
  businessType: "개인",
  businessNumber1: "",
  businessNumber2: "",
  businessNumber3: "",
  managerName: "",
  phoneNumber1: "",
  phoneNumber2: "",
  phoneNumber3: "",
  managerPhone1: "",
  managerPhone2: "",
  managerPhone3: "",
  email1: "",
  email2: "",
  companyAddress1: "",
  companyAddress2: "",
  addressDetail: "",
  companyAddress21: "",
  companyAddress22: "",
  addressDetail2: "",
  remarks: "",
  file: {} as saveFile,
  seal: {} as saveFile,
  seal2: {} as saveFile,
  businessLicense: "",
  casualSeal: "",
  registeredSeal: "",
  사용인감등록여부: false,
  인감등록여부: false,
});

const isPreviewTracking = ref(false);
const previewVisible = ref(false);
const previewImageUrl = ref('');
const previewPosition = ref({ x: 0, y: 0 });
const sealSeq = ref();
const sealFileUrl = ref()
const businessnoUrl = ref()
const showFilePreview = async (event: MouseEvent, file: any) => {
  previewPosition.value = {
    x: event.clientX + 10,
    y: event.clientY + 10
  };
  
  try {
    if (file && file.저장순번) {
      const fileType = file.원파일명.toLowerCase().endsWith('.pdf') ? 'pdf' : 'image';
      // 파일 다운로드 (ArrayBuffer 형식으로)
      let res
      let blob
      if(fileType !== 'pdf') {
        if(file.자료식별값2 === '도장') {
          console.log(sealFileUrl.value);
          if(sealFileUrl.value) {
            previewImageUrl.value = URL.createObjectURL(sealFileUrl.value);
          } else {
            res = await userAPI.sealFile(file.저장순번,file.자료식별값3,'3111');
            blob = new Blob([res.data]);
            previewImageUrl.value = URL.createObjectURL(blob);
            sealFileUrl.value = blob;
          }
        } else if(file.자료식별값2 === '사업자등록증') {
          if(businessnoUrl.value) {
            previewImageUrl.value = URL.createObjectURL(businessnoUrl.value);
          } else {
            res = await userAPI.priviewFile(file.저장순번);
            blob = new Blob([res.data]);
            previewImageUrl.value = URL.createObjectURL(blob);
            businessnoUrl.value = blob;
          }
        }
      } else {
      previewImageUrl.value = require('@/assets/images/pdf.png');
      }
      previewVisible.value = true;
      isPreviewTracking.value = true;
    }
  } catch (error) {
    console.error('파일 미리보기 로드 실패:', error);
  }
};

const handleGlobalMouseMove = (event: MouseEvent) => {
  if (!isPreviewTracking.value || !previewVisible.value) return;
  
  // 미리보기 요소 참조
  // 이벤트가 발생한 요소 확인
  const target = event.target as HTMLElement;
  const isFileNameElement = target.closest('.file-name');

  // file-name 클래스를 가진 요소가 아닌 곳에 마우스가 있으면 미리보기 숨김
  if (!isFileNameElement) {
    hideSealPreview();
    return;
  }
  
};

const hideSealPreview = () => {
  previewVisible.value = false;
  isPreviewTracking.value = false;
  if (previewImageUrl.value && previewImageUrl.value.startsWith('blob:')) {
    URL.revokeObjectURL(previewImageUrl.value);
    previewImageUrl.value = '';
  }
};

const toggleFileUploadPop = ref(false);
const closePopup = (data: any) => {
  toggleFileUploadPop.value = false;
  if(data.refresh) {
    userDetail();
  }
};
const openFilePop = (data: string,data2: string|null) => {
  fileParam.value.등록구분 = data;
  fileParam.value.도장구분 = data2;
  if(data2) {
    sealSeq.value = form.seal?.저장순번;
  }
  toggleFileUploadPop.value = true;
};
// 주소 검색
const searchAddr = (seq: number) => {
  const daum = (window as any).daum;
  new daum.Postcode({
    oncomplete(data: any) {
      if(seq === 1) {
        form.companyAddress1 = data.zonecode;
        form.companyAddress2 = data.address;
      } else {
        form.companyAddress21 = data.zonecode;
        form.companyAddress22 = data.address;
      }
    },
  }).open();
};
const fileParam:MemberFileParam = ref({
  등록구분: null,
  도장구분: null,
  인감비밀번호: null
})
const img = ref()
const imgPreview = () => {
  
  userAPI
    .sealFile(1, '사용인감', '')
    .then((res: any) => {
      const 사용인감 = res.data
      const url = window.URL.createObjectURL(new Blob([사용인감]))
      img.value = url
    })
}

// API 호출 및 데이터 바인딩
const userDetail = async () => {
  try {
    const res = await userAPI.mypage();
    const userData = res.data.data;
    form.companyName = userData.사업자명 || "";
    form.businessType = userData.사업자구분;
    form.businessNumber1 = userData.사업자번호?.slice(0, 3) || "";
    form.businessNumber2 = userData.사업자번호?.slice(3, 5) || "";
    form.businessNumber3 = userData.사업자번호?.slice(5) || "";
    form.managerName = userData.담당자명 || "";
    form.phoneNumber1 = userData.대표자전화번호?.slice(0, 3) || "";
    form.phoneNumber2 = userData.대표자전화번호?.slice(3, 7) || "";
    form.phoneNumber3 = userData.대표자전화번호?.slice(7) || "";
    form.managerPhone1 = userData.담당자전화번호?.slice(0, 3) || "";
    form.managerPhone2 = userData.담당자전화번호?.slice(3, 7) || "";
    form.managerPhone3 = userData.담당자전화번호?.slice(7) || "";
    form.email1 = userData.담당자이메일?.split("@")[0] || "";
    form.email2 = userData.담당자이메일?.split("@")[1] || "";
    form.companyAddress1 = userData.우편번호 || "";
    form.companyAddress2 = userData.주소 || "";
    form.addressDetail = userData.상세주소 || "";
    form.companyAddress21 = userData.우편번호2 || "";
    form.companyAddress22 = userData.주소2 || "";
    form.addressDetail2 = userData.상세주소2 || "";``
    form.remarks = userData.비고 || "";
    form.file = userData.사업자등록증;
    form.seal = userData.사용인감;
    form.seal2 = userData.인감;
    form.사용인감등록여부 = userData.사용인감등록여부 || false;
    form.인감등록여부 = userData.인감등록여부 || false;
    // form.fileName = userData.사업자등록증?.[0]?.원파일명 || "";
  } catch (error) {
    console.error("Failed to fetch user details:", error);
  }
  console.log(form.file);
};

// 수정 API 호출
const updateUser = async () => {
  try {
    // 서버에 전송할 데이터 형식
    const payload: Partial<Member> = {
      사업자명: form.companyName,
      사업자구분: form.businessType,
      사업자번호: `${form.businessNumber1}${form.businessNumber2}${form.businessNumber3}`,
      대표자명: form.managerName,
      대표자전화번호: `${form.phoneNumber1}${form.phoneNumber2}${form.phoneNumber3}`,
      담당자명: form.managerName,
      담당자전화번호: `${form.managerPhone1}${form.managerPhone2}${form.managerPhone3}`,
      담당자이메일: `${form.email1}@${form.email2}`,
      우편번호: form.companyAddress1,
      주소: form.companyAddress2,
      상세주소: form.addressDetail,
      우편번호2: form.companyAddress21,
      주소2: form.companyAddress22,
      상세주소2: form.addressDetail2,
      비고: form.remarks,
    };

    // PATCH 요청
    await userAPI.updateUser(payload).then((res) => {
      console.log("res", res);
      alert("수정이 완료되었습니다!");
    });
  } catch (error) {
    console.error("수정 실패:", error);
    alert("수정에 실패했습니다. 다시 시도해주세요.");
  }
};
const downloadFile = (file: any) => {
  if (file) {
    userAPI.downloadUserFile(file.저장순번, file.원파일명);
  }
}
onMounted(() => {
  userDetail();
  document.addEventListener('mousemove', handleGlobalMouseMove);
});

onBeforeUnmount(() => {
  // 이벤트 리스너 제거
  document.removeEventListener('mousemove', handleGlobalMouseMove);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[49] || (_cache[49] = _createElementVNode("div", { class: "page_header" }, [
        _createElementVNode("div", { class: "page_header_circle" }),
        _createTextVNode(" 마이페이지 ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "join_header" }, "정보입력", -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { for: "companyName" }, "사업자명", -1)),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "companyName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.companyName) = $event))
                }, null, 512), [
                  [_vModelText, form.companyName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { for: "businessType" }, "사업자구분", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    value: "개인",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.businessType) = $event))
                  }, null, 512), [
                    [_vModelRadio, form.businessType]
                  ]),
                  _cache[31] || (_cache[31] = _createTextVNode(" 개인 "))
                ]),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    value: "법인",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.businessType) = $event))
                  }, null, 512), [
                    [_vModelRadio, form.businessType]
                  ]),
                  _cache[32] || (_cache[32] = _createTextVNode(" 법인 "))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { for: "businessNumber" }, "사업자번호", -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "businessNumber1",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.businessNumber1) = $event))
                }, null, 512), [
                  [_vModelText, form.businessNumber1]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "businessNumber2",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.businessNumber2) = $event))
                }, null, 512), [
                  [_vModelText, form.businessNumber2]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "businessNumber3",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.businessNumber3) = $event))
                }, null, 512), [
                  [_vModelText, form.businessNumber3]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { for: "managerName" }, "대표자명", -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "managerName",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.managerName) = $event))
                }, null, 512), [
                  [_vModelText, form.managerName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { for: "phoneNumber" }, "대표자 전화번호", -1)),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "phoneNumber1",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.phoneNumber1) = $event))
                }, null, 512), [
                  [_vModelText, form.phoneNumber1]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "phoneNumber2",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.phoneNumber2) = $event))
                }, null, 512), [
                  [_vModelText, form.phoneNumber2]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "phoneNumber3",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.phoneNumber3) = $event))
                }, null, 512), [
                  [_vModelText, form.phoneNumber3]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[37] || (_cache[37] = _createElementVNode("label", { for: "managerPhone" }, "담당자 전화번호", -1)),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "managerPhone1",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.managerPhone1) = $event))
                }, null, 512), [
                  [_vModelText, form.managerPhone1]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "managerPhone2",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.managerPhone2) = $event))
                }, null, 512), [
                  [_vModelText, form.managerPhone2]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "managerPhone3",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.managerPhone3) = $event))
                }, null, 512), [
                  [_vModelText, form.managerPhone3]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { for: "taxEmail" }, "담당자 이메일", -1)),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  class: "email1",
                  type: "text",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.email1) = $event))
                }, null, 512), [
                  [_vModelText, form.email1]
                ]),
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "dot" }, "@", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "email2",
                  type: "text",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.email2) = $event))
                }, null, 512), [
                  [_vModelText, form.email2]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { for: "companyAddress" }, "주소", -1)),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  class: "address1",
                  readonly: "",
                  type: "search",
                  id: "companyAddress1",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.companyAddress1) = $event)),
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (searchAddr(1)))
                }, null, 512), [
                  [_vModelText, form.companyAddress1]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "address2",
                  type: "text",
                  id: "companyAddress2",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.companyAddress2) = $event))
                }, null, 512), [
                  [_vModelText, form.companyAddress2]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { for: "addressDetail" }, "상세주소", -1)),
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "addressDetail",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.addressDetail) = $event))
                }, null, 512), [
                  [_vModelText, form.addressDetail]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _cache[42] || (_cache[42] = _createElementVNode("label", { for: "companyAddress" }, "주소2", -1)),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  class: "address1",
                  readonly: "",
                  type: "search",
                  id: "companyAddress1",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.companyAddress21) = $event)),
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (searchAddr(2)))
                }, null, 512), [
                  [_vModelText, form.companyAddress21]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "address2",
                  type: "text",
                  id: "companyAddress2",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.companyAddress22) = $event))
                }, null, 512), [
                  [_vModelText, form.companyAddress22]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[43] || (_cache[43] = _createElementVNode("label", { for: "addressDetail" }, "상세주소2", -1)),
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "addressDetail",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.addressDetail2) = $event))
                }, null, 512), [
                  [_vModelText, form.addressDetail2]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _cache[44] || (_cache[44] = _createElementVNode("label", { for: "file" }, "사업자등록증", -1)),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: "file-name",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (downloadFile(form.file))),
                  style: _normalizeStyle({ color: form.file ? '#0078db' : '#db0028' }),
                  onMouseover: _cache[24] || (_cache[24] = ($event: any) => (showFilePreview($event, form.file))),
                  onMouseleave: hideSealPreview
                }, _toDisplayString(form.file ? form.file?.원파일명 : '미등록'), 37),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(isEmpty)(form.file) ? '' : _unref(formatTimeAgo)(form.file.등록일시!)), 1),
                _createElementVNode("label", {
                  for: "file",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (openFilePop('사업자등록증',null)))
                }, _toDisplayString(_unref(isEmpty)(form.file) ? '파일 등록' : '파일 재등록'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _cache[45] || (_cache[45] = _createElementVNode("label", { for: "remarks" }, "사용인감", -1)),
              _createElementVNode("div", _hoisted_30, [
                (form.사용인감등록여부)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "file-name",
                      style: _normalizeStyle({ color: form.사용인감등록여부 ? '#0078db' : '#db0028' }),
                      onMouseover: _cache[26] || (_cache[26] = ($event: any) => (showFilePreview($event, form.seal))),
                      onMouseleave: hideSealPreview
                    }, _toDisplayString(form.사용인감등록여부 ? '등록완료' : '미등록'), 37))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(isEmpty)(form.seal) ? '' : _unref(formatTimeAgo)(form.seal.등록일시!)), 1),
                _createElementVNode("label", {
                  for: "file",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (openFilePop('도장','사용인감')))
                }, _toDisplayString(_unref(isEmpty)(form.seal) ? '파일 등록' : '파일 재등록'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[46] || (_cache[46] = _createElementVNode("label", { for: "remarks" }, "인감", -1)),
              _createElementVNode("div", _hoisted_33, [
                (form.인감등록여부)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "file-name",
                      style: _normalizeStyle({ color: form.인감등록여부 ? '#0078db' : '#db0028' })
                    }, _toDisplayString(form.인감등록여부 ? '등록완료' : '미등록'), 5))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(isEmpty)(form.seal2) ? '' : _unref(formatTimeAgo)(form.seal2.등록일시!)), 1),
                _createElementVNode("label", {
                  for: "file",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (openFilePop('도장','인감')))
                }, _toDisplayString(_unref(isEmpty)(form.seal2) ? '파일 등록' : '파일 재등록'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[47] || (_cache[47] = _createElementVNode("label", { for: "remarks" }, "비고", -1)),
              _createElementVNode("div", _hoisted_36, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "remarks",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((form.remarks) = $event))
                }, null, 512), [
                  [_vModelText, form.remarks]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", { class: "submit-btn" }, [
            _createElementVNode("button", {
              class: "submit-button",
              onClick: updateUser
            }, "수정하기")
          ])
        ])
      ])
    ]),
    (previewVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "seal-preview",
          style: _normalizeStyle({ left: previewPosition.value.x + 'px', top: previewPosition.value.y + 'px' })
        }, [
          _createElementVNode("img", { src: previewImageUrl.value }, null, 8, _hoisted_37)
        ], 4))
      : _createCommentVNode("", true),
    (toggleFileUploadPop.value)
      ? (_openBlock(), _createBlock(UserFileUploadPop, {
          key: 1,
          등록구분: fileParam.value.등록구분!,
          도장구분: fileParam.value.도장구분,
          oldSeq: sealSeq.value,
          onClosePopup: closePopup
        }, null, 8, ["등록구분", "도장구분", "oldSeq"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})